import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "../styles/Home.css";
import Hero from "./Hero";



import Navbar from "../components/Navbar";
import "../styles/Home.css";
import whoImage from "../assets/who-we-are.webp";
import whyImage from "../assets/why-choose-us.webp";

// Partner logos
import partner1 from "../assets/BigMinds.webp";
import partner2 from "../assets/TechBairn.webp";
import partner3 from "../assets/Amiker.webp";
import partner4 from "../assets/Travysys.webp";
import partner5 from "../assets/BugHight.webp";
import partner6 from "../assets/Kanu.webp";
import partner7 from "../assets/web3.webp";

// (Team images removed since the team section is no longer used)

// Industry icons
import bankingIcon from "../assets/banking.png";
import educationIcon from "../assets/education.png";
import hospitalIcon from "../assets/hospital.png";
import logisticsIcon from "../assets/logistics.png";
import startupIcon from "../assets/startup.png";
import travelIcon from "../assets/travel.png";
import retailIcon from "../assets/retails.png";
import defenseIcon from "../assets/rank.png";

// Other icons
import icon1 from "../assets/time.png";
import icon2 from "../assets/consulting.png";
import icon3 from "../assets/staff.png";
import icon4 from "../assets/services.png";

// Step icons
import stepIcon1 from "../assets/contactus.png";
import stepIcon2 from "../assets/consultation.png";
import stepIcon3 from "../assets/price.png";
import stepIcon4 from "../assets/project.png";

// testimoni data
import Amiker from "../assets/Amiker.webp";
import Travysys from "../assets/Travysys.webp";
import BugHight from "../assets/BugHight.webp";

/* ======================================================
   Static Data (moved outside of components for reuse)
===================================================== */
const SERVICES = [
  {
    title: "TStaaS (Tech Stack as a Service)",
    description:
      "Expert advisory, tailored tech solutions, security, and cloud deployment.",
  },
  {
    title: "Cybersecurity Solutions",
    description:
      "Protecting your digital assets with state-of-the-art security solutions.",
  },
  {
    title: "Webapp Development",
    description:
      "Building responsive and scalable web applications tailored to your needs.",
  },
  {
    title: "AI/ML Solutions",
    description:
      "Integrating intelligent systems and machine learning algorithms for data-driven decisions.",
  },
  {
    title: "Cloud Solutions",
    description:
      "Empowering your business with robust and scalable cloud computing services.",
  },
];

const APPROACHES = [
  {
    icon: icon1,
    title: "Project-Based",
    description:
      "We handle projects end-to-end, from planning to deployment, ensuring timely delivery and transparent reporting.",
  },
  {
    icon: icon2,
    title: "Consulting & Advisory",
    description:
      "Our experts guide you in selecting the right technologies and strategies for scalable, secure solutions.",
  },
  {
    icon: icon3,
    title: "Co-Development",
    description:
      "We collaborate with your in-house team to accelerate development, optimize workflows, and share best practices.",
  },
  {
    icon: icon4,
    title: "Fully Managed Services",
    description:
      "Outsource your IT operations entirely to us, and we'll maintain, support, and evolve your infrastructure.",
  },
];

const STEPS = [
  {
    icon: stepIcon1,
    title: "Contact Us",
    description:
      "Fill out our secure contact form and schedule a meeting to discuss your project goals.",
  },
  {
    icon: stepIcon2,
    title: "Get a Consultation",
    description:
      "Hop on a call with our team to explore the feasibility of your project and outline a plan of action.",
  },
  {
    icon: stepIcon3,
    title: "Receive an Estimate",
    description:
      "Based on your requirements, we'll propose a budget and timeline, giving you a clear project roadmap.",
  },
  {
    icon: stepIcon4,
    title: "Kick Off Your Project",
    description:
      "Once approved, our specialized team dives right in, ensuring a smooth and timely project kickoff.",
  },
];

/* ========================================
   Who Are We Section
======================================= */
const WhoAreWe = React.memo(() => (
  <section className="who-are-we">
    <div className="who-content">
      <div className="who-text">
        <h2>Who We Are – Your Digital Defense Experts</h2>
        <p>
          At EncryptArx, we protect your digital world with smart, reliable cybersecurity and IT solutions.
          Our experts build secure, high-performance systems that don't just defend against threats they help you grow and innovate.
          We tackle real-world security challenges with precision, keeping your operations strong, seamless, and ready for the future.
        </p>
        <a className="App-link" href="/about">
          Learn More
        </a>
      </div>
      <div className="who-image">
        <img src={whoImage} alt="Who We Are" loading="lazy" />
      </div>
    </div>
  </section>
));

/* ========================================
   What Do We Offer Section
======================================= */
const WhatWeOffer = React.memo(() => (
  <section className="what-we-offer">
    <h2>What Do We Offer?</h2>
    <div className="offer-cards">
      {SERVICES.map((service, index) => (
        <div key={index} className="offer-card">
          <h3>{service.title}</h3>
          <p>{service.description}</p>
          <a href="/services" className="App-link">
            Learn More
          </a>
        </div>
      ))}
    </div>
  </section>
));

/* ========================================
   Why Choose Us Section
======================================= */
const WhyChooseUs = React.memo(() => (
  <section className="why-choose-us">
    <div className="why-content">
      <div className="why-image">
        <img src={whyImage} alt="Why Choose Us" loading="lazy" />
      </div>
      <div className="why-text">
        <h2>Why Choose Us?</h2>
        <p>
          At EncryptArx, we blend cutting-edge technology with an unwavering commitment to security and innovation.
          Our expert team delivers customized solutions that empower your digital transformation.
        </p>
        <ul>
          <li>Advanced cybersecurity solutions</li>
          <li>Strategic, future-ready IT planning</li>
          <li>Scalable and efficient tech architectures</li>
          <li>Seamless cloud integration and optimization</li>
        </ul>
      </div>
    </div>
  </section>
));

/* ========================================
   Collaboration Approaches Section
======================================= */
const CollaborationApproaches = React.memo(() => (
  <section className="collaboration-approaches">
    <h2>Collaboration Frameworks</h2>
    <div className="approaches-grid">
      {APPROACHES.map((item, index) => (
        <div className="approach-card" key={index}>
          <img
            src={item.icon}
            srcSet={`
              ${item.icon} 320w,
              ${item.icon} 480w,
              ${item.icon} 800w
            `}
            sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
            alt={item.title}
            className="approach-icon"
            loading="lazy"
          />
          <h3>{item.title}</h3>
          <p>{item.description}</p>
        </div>
      ))}
    </div>
  </section>
));

/* ========================================
   R&D Department Section
======================================= */
const RnDSection = React.memo(() => (
  <section className="rnd-section">
    <div className="rnd-content">
      <h2>Our R&D Department</h2>
      <p>
        At EncryptArx, our dedicated R&D team is hard at work developing innovative products that redefine digital security and IT solutions.
        Discover how our pioneering research drives our technology forward.
      </p>
      <a href="/products" className="App-link">
        Explore
      </a>
    </div>
  </section>
));

/* ========================================
   Our Partners Section (Carousel with Logos)
======================================= */
const OurPartners = React.memo(() => {
  const partners = [partner1, partner2, partner3, partner4, partner5, partner6, partner7];
  const partnerList = [...partners, ...partners];

  return (
    <section className="our-partners">
      <div className="partners-content">
        <h2>Brands that Trust Us!</h2>
        <div className="partners-carousel">
          <div className="partners-track">
            {partnerList.map((logo, index) => (
              <div key={index} className="partner-logo">
                <img
                  src={logo}
                  srcSet={`
                    ${logo} 320w,
                    ${logo} 480w,
                    ${logo} 800w
                  `}
                  sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
                  alt={`Partner ${index + 1}`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
});

/* ========================================
   Testimonial Slider Section
======================================= */
const testimonialData = [
  {
    id: "option-1",
    author: "Monoj Borah",
    role: "Founder & CEO, Travysys",
    image: Travysys,
    text: "The tech support team came to us when we were in a dire situation. Every interaction with the tech support team has been a pleasure. Whenever we needed help, they come up with solutions. Their quick response times and deep knowledge  have made all the difference for our business. Truly exceptional service!",
  },
  {
    id: "option-2",
    author: "Amit Saraogi",
    role: "Owner, Amiker",
    image: Amiker,
    text: "EncryptArx has delivered an exceptional marketing app tailored to our logistics business needs. The app streamlines our operations, enhances customer engagement, and provides valuable insights, making our marketing efforts more efficient. Their expertise in IT solutions, combined with a professional and responsive team, has made this collaboration a great success. We highly recommend EncryptArx for innovative and reliable software solutions.",
  },
  {
    id: "option-3",
    author: "Biswajeet Ray",
    role: "CEO, Bugite",
    image: BugHight,
    text: "Exceptional service from start to finish. The developers took the time to understand my vision and turned it into reality. The website looks amazing, loads fast, and works flawlessly on all devices. I've received so much positive feedback from customers.",
  },

  /*
  {
    id: "option-4",
    author: "Maria Rodriguez",
    role: "Buisness Owner",
    image: "https://i.pravatar.cc/150?img=16",
    text: "I was impressed with the level of expertise and dedication they brought to the project, providing valuable insights throughout the process and delivering a site that's both beautiful and functional.",
  },
  {
    id: "option-5",
    author: "Gordon Waltz",
    role: "Buisness Owner",
    image: "https://i.pravatar.cc/150?img=17",
    text: "The web development service went above and beyond to deliver a website that truly captures our company's personality. They were incredibly responsive and made sure all my requests were addressed quickly. I especially appreciate how they kept me in the loop every step of the way. The end result is fantastic!",
  },
  */
]; 

const TestimonialSlider = React.memo(() => (
  <section className="testimonials" style={{ marginTop: "3rem" }}>
    <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>Our Happy Clients!</h2>
    <div className="quotes">
      {testimonialData.map((testimonial, index) => (
        <React.Fragment key={testimonial.id}>
          <input
            type="radio"
            id={testimonial.id}
            name="panel"
            className="sr-only"
            defaultChecked={index === 0}
          />
          <article>
            <blockquote>
              <p>
                <span className="clip clip-left"></span>
                {testimonial.text}
              </p>
            </blockquote>
            <div className="user">
              <div>
                <p>{testimonial.author}</p>
                <p>{testimonial.role}</p>
              </div>
              <img
                src={testimonial.image}
                srcSet={`
                  ${testimonial.image} 320w,
                  ${testimonial.image} 480w,
                  ${testimonial.image} 800w
                `}
                sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
                alt={testimonial.author}
                loading="lazy"
              />
            </div>
          </article>
        </React.Fragment>
      ))}
    </div>
    <div className="dots">
      {testimonialData.map((testimonial, index) => (
        <label
          key={testimonial.id}
          id={`toggle-${index + 1}`}
          htmlFor={testimonial.id}
          aria-label={`toggle panel ${index + 1}`}
        ></label>
      ))}
    </div>
  </section>
));

/* ========================================
   FAQ Section
======================================= */
const faqData = [
  {
    id: 1,
    question: "How can EncryptArx help my business with cybersecurity?",
    answer:
      "EncryptArx provides tailored cybersecurity solutions, including penetration testing, threat detection, compliance audits, and secure software consulting, to protect your business from cyber threats.",
  },
  {
    id: 2,
    question:
      "Do you provide industry-specific security solutions for [financial/healthcare/e-commerce/etc.] businesses?",
    answer:
      "Yes! We customize our security and AI-driven solutions for industries like finance, healthcare, government, e-commerce, and tech startups to meet specific compliance and security needs.",
  },
  {
    id: 3,
    question: "My company is developing AI/ML-based applications. How can you help?",
    answer:
      "EncryptArx ensures your AI/ML models are secure, reliable, and protected from adversarial attacks while maintaining explainability and performance.",
  },
  {
    id: 4,
    question: "What are the signs that my company needs a cybersecurity assessment?",
    answer:
      "If you're experiencing frequent system breaches, phishing attacks, compliance challenges, or want to improve security, an assessment can identify and fix vulnerabilities.",
  },
  {
    id: 5,
    question: "What makes EncryptArx the right choice for my business?",
    answer:
      "Unlike traditional cybersecurity firms, EncryptArx integrates AI/ML with deep-tech expertise to offer smarter, more adaptive security solutions. We don't just protect your business, we help you stay ahead of evolving cyber threats.",
  },
  {
    id: 6,
    question: "Will EncryptArx's security solutions work with my existing IT systems?",
    answer:
      "Yes! Our solutions integrate seamlessly with your current infrastructure, enhancing security without disrupting your daily operations.",
  },
  {
    id: 7,
    question: "How can EncryptArx improve my company's security posture?",
    answer:
      "EncryptArx delivers end-to-end cybersecurity solutions with protective controls which combine risk assessment and penetration tests together with compliance requirements for addressing developing cyber threats.",
  },
];

const FaqSection = () => {
  const [activeId, setActiveId] = useState(null);

  const toggleFaq = (id) => {
    setActiveId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">FAQ</h2>
        {faqData.map((faq) => (
          <div className="faq-card" key={faq.id}>
            <div className="faq-question" onClick={() => toggleFaq(faq.id)}>
              <span className="faq-badge">{faq.id}</span>
              {faq.question}
            </div>
            {activeId === faq.id && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

/* ========================================
   Blog Section
======================================= */
const blogData = [
  {
    id: 1,
    title: "Fake News Meets Deepfakes: The Technology Behind Modern Misinformation",
    snippet:
      "Dive into the world of deepfakes and discover how advanced AI is used to create sophisticated misinformation.",
    image: "https://r9news.in/wp-content/uploads/2024/07/thumbnail.jpg",
    link: "https://r9news.in/2024/07/16/fake-news-meets-deepfakes-the-technology-behind-modern-misinformation/"
  },
  {
    id: 2,
    title: "How Our Useless E-Mails Can Be Dangerous to Our Environment",
    snippet:
      "Discover how seemingly harmless e-mails contribute to carbon emissions and what steps we can take to mitigate their impact.",
    image: "https://cdn.pixabay.com/photo/2018/03/22/02/37/email-3249062_960_720.png",
    link: "https://kunaldas9.medium.com/how-our-useless-e-mail-can-be-dangerous-to-our-environment-4f39ca96a033"
  },
];

const BlogSection = React.memo(() => (
  <section className="new-blog-section">
    <div className="new-blog-container">
      <h2 className="new-blog-title">Fresh Insights!</h2>
      <div className="new-blog-grid">
        {blogData.map((blog) => (
          <motion.div
            key={blog.id}
            className="new-blog-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <div className="new-blog-card-image">
              <img
                src={blog.image}
                srcSet={`
                  ${blog.image} 320w,
                  ${blog.image} 480w,
                  ${blog.image} 800w
                `}
                sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
                alt={blog.title}
                loading="lazy"
              />
            </div>
            <div className="new-blog-card-content">
              <h3>{blog.title}</h3>
              <p>{blog.snippet}</p>
              <a 
                href={blog.link} 
                className="new-blog-link" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Read More
              </a>
            </div>
          </motion.div>
        ))}
      </div>
      <div className="resources-button-wrapper">
        <Link to="/resources" className="resources-button">
          Explore Resources
        </Link>
      </div>
    </div>
  </section>
));

/* ========================================
   Industries Section
======================================= */
const IndustriesSection = React.memo(() => {
  const industries = [
    { name: "Defense", icon: defenseIcon },
    { name: "Startups", icon: startupIcon },
    { name: "Banking", icon: bankingIcon },
    { name: "Education", icon: educationIcon },
    { name: "Hospital", icon: hospitalIcon },
    { name: "Logistics", icon: logisticsIcon },
    { name: "Travel", icon: travelIcon },
    { name: "Retail", icon: retailIcon }
  ];

  return (
    <section
      className="industries-section"
      style={{
        background: "linear-gradient(135deg, #232526, #414345)",
        padding: "4rem 2rem",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "2rem", color: "#03dac6" }}>
        Industries We Serve
      </h2>
      <div className="industries-grid">
        {industries.map((industry, index) => (
          <motion.div
            key={industry.name}
            className="industry-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
          >
            <img
              src={industry.icon}
              srcSet={`
                ${industry.icon} 320w,
                ${industry.icon} 480w,
                ${industry.icon} 800w
              `}
              sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
              alt={industry.name}
              className="industry-icon"
              loading="lazy"
            />
            <h3 className="industry-name">{industry.name}</h3>
          </motion.div>
        ))}
      </div>
    </section>
  );
});

/* ========================================
   Get Started Section
======================================= */
const GetStarted = React.memo(() => (
  <section className="get-started">
    <h2>Take the First Step Now!</h2>
    <div className="steps-grid">
      {STEPS.map((step, index) => (
        <div className="step-card" key={index}>
          <img
            src={step.icon}
            srcSet={`
              ${step.icon} 320w,
              ${step.icon} 480w,
              ${step.icon} 800w
            `}
            sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
            alt={step.title}
            className="step-icon"
            loading="lazy"
          />
          <h3>{step.title}</h3>
          <p>{step.description}</p>
        </div>
      ))}
    </div>
    <Link to="/contact" className="cta-button">
      Get Started
    </Link>
  </section>
));

/* ========================================
   Final Home Component (TeamSection removed)
======================================= */
const Home = () => {
  return (
    <div className="home-container">
      {/* Navigation Bar */}
      <Navbar />

      {/* Hero Section */}
      <Hero />

      {/* Other Sections */}
      <WhoAreWe />
      <WhatWeOffer />
      <WhyChooseUs />
      {/* TeamSection has been removed */}
      <CollaborationApproaches />
      <RnDSection />
      <OurPartners />
      <TestimonialSlider />
      <IndustriesSection />
      <FaqSection />
      <GetStarted />
      <BlogSection />
    </div>
  );
};

export default Home;
